import Flex from '@/elements/Flex'
import Text from '@/elements/Text'
import Button from '@/elements/Button'
import usePersistedState from '@/hooks/usePersistedState'
import { colors } from '@/utils/theme'
import usePushNotifications from '@/hooks/usePushNotifications'
import { IS_MOBILE_APP } from '@/constants'

const PUSH_NOTIFICATION_DISMISS_DURATION_KEY = 'pushNotificationPopUpDismissedAt'
const PUSH_NOTIFICATION_INTERVAL_MS = 7 * 24 * 60 * 60 * 1000 // 7 days

const PushNotificationPopUp = () => {
  const [dismissedAt, setDismissedAt] = usePersistedState(
    PUSH_NOTIFICATION_DISMISS_DURATION_KEY, null
  )

  const { myDeviceIsRegistered, addNewDeviceToken, loading } = usePushNotifications({})

  const shouldShowPopUp = !dismissedAt
    || (Date.now() - dismissedAt) > PUSH_NOTIFICATION_INTERVAL_MS

  if (!IS_MOBILE_APP || !shouldShowPopUp) return null
  if (loading || myDeviceIsRegistered) return null

  return (
    <Flex
      wfull
      p={4}
      gap={3}
      align='center'
      className='card'
      style={{ backgroundColor: colors['gray-light-20'] }}
    >
      <Text align='center' variant='h2'>
        Stay Updated on the Go!
      </Text>
      <Text align='center' style={{ hyphens: 'none' }}>
        Looks like you haven't enabled push notifications for this device yet.
      </Text>
      <Flex wfull gap={2}>
        <Button fullWidth variant='primary' onClick={addNewDeviceToken}>
          Enable Push Notifications
        </Button>
        <Button fullWidth variant='secondary' onClick={() => setDismissedAt(Date.now())}>
          Remind Me in a Week
        </Button>
      </Flex>
    </Flex>
  )
}

export default PushNotificationPopUp
